import { works } from 'data/home.dummy'
import BoxIcon from '../../../cwp-components/utils/BoxIcon'

const LawyerTypes = () => {
  return (
    <div className='flex justify-center sm:mt-24 mt-4 px-2 sm:px-4 sm:mb-24 mb-4'>
      <div className='w-full max-w-screen-lg text-center'>
        <div className='flex flex-row justify-center gap-2 sm:gap-10 mb-5'>
          {works.map((work, idx) => (
            <div key={idx} className='w-1/3 sm:w-1/4'>
              <BoxIcon
                title={work.title}
                icon={work.icon}
                caption={work.caption}
                bgColor={work.bgColor}
                size={16}
              />
            </div>
          ))}
        </div>

        <p className='text-sm mb-2'>
          Every Find a Lawyer booking comes with complaint support.
        </p>
        <a
          href='/complaint-assistance'
          className='text-primary underline text-sm'
        >
          Learn more about Complaint Assistance
        </a>
      </div>
    </div>
  )
}

export default LawyerTypes
